import script from "./DevelopView.vue?vue&type=script&setup=true&lang=js"
export * from "./DevelopView.vue?vue&type=script&setup=true&lang=js"

import "./DevelopView.vue?vue&type=style&index=0&id=3ca5ffaa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca5ffaa"]])

export default __exports__